var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMakeLarger = function SvgMakeLarger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    style: {
      color: "#2d4e6d"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 1.333a.667.667 0 1 0 0 1.334h1.058L9.529 5.529a.667.667 0 0 0 .942.942l2.862-2.862v1.058a.667.667 0 1 0 1.334 0V2A.666.666 0 0 0 14 1.333h-2.667ZM2.667 12.391v-1.058a.667.667 0 1 0-1.334 0V14a.667.667 0 0 0 .667.667h2.667a.667.667 0 0 0 0-1.334H3.609l2.862-2.862a.667.667 0 0 0-.942-.942L2.667 12.39Z"
  })));
};
export default SvgMakeLarger;